import { Button, Dialog, DialogBody, DialogContent, DialogFooter } from '@civilgrid/ui/components';
import { Action } from '~/authorizations';
import Can from '~/authorizations/Can';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import { useLandRightsTitleZipsViaS3Enabled } from '~/hooks/useLandRightsTitleZipsViaS3Enabled';
import { singleTitleCost } from '~/pages/projectDetails/landRights/constant';
import { orderMultipleTitleReports } from '~/pages/projectDetails/landRights/helper';

interface ConfirmDocumentsOrderModalProps {
  isDocModalOpen: boolean;
  setIsDocModalOpen: (IsDocModalOpen: boolean) => void;
  docsParams?: { DocId: string; CmtId: string }[];
  projectId: string;
  currentOrganizationId?: string;
}

export const ConfirmDocumentsOrderModal = ({
  isDocModalOpen,
  setIsDocModalOpen,
  docsParams,
  projectId,
  currentOrganizationId,
}: ConfirmDocumentsOrderModalProps) => {
  const titleZipsViaS3 = useLandRightsTitleZipsViaS3Enabled();
  const docCount = docsParams?.length ?? 0;
  const totalCost = singleTitleCost.multiply(docCount);
  return (
    <Dialog open={isDocModalOpen} onOpenChange={setIsDocModalOpen}>
      <DialogContent
        title="Order Report"
        className="z-[130] w-auto min-w-min max-w-[75vw] shadow-lg"
        overlayClassName="z-[120]"
        data-testid="land-rights-docs-order-dialog"
      >
        <DialogBody className="text-sm">
          {`Would you like to order ${docCount} report${docCount > 1 ? 's' : ''} at a cost of `}
          {totalCost.toFormat()}?
        </DialogBody>
        <DialogFooter>
          <Button
            variant="secondary"
            type="reset"
            onClick={() => setIsDocModalOpen(false)}
            data-testid="land-rights-doc-modal-close"
          >
            Close
          </Button>
          <Can action={singleTitleCost.getAmount() > 0 ? Action.OrderPaidReports : Action.OrderFreeReports}>
            <Button
              type="submit"
              data-testid="land-rights-doc-modal-accept"
              onClick={() => {
                orderMultipleTitleReports({
                  projectId,
                  docsParams,
                  viaSignedUrl: titleZipsViaS3,
                }).then(({ successCount, failureCount }) => {
                  if (successCount > 0) {
                    captureTypedPosthogEvent(POSTHOG_EVENTS.landRightsDataDownloaded, {
                      project_id: projectId,
                      organization_id: currentOrganizationId,
                      type: 'titleDocument',
                      doc_count: successCount,
                    });
                  }
                  if (failureCount > 0) {
                    captureTypedPosthogEvent(POSTHOG_EVENTS.landRightsDataDownloadFailed, {
                      project_id: projectId,
                      organization_id: currentOrganizationId,
                      type: 'titleDocument',
                      doc_count: failureCount,
                    });
                  }
                });
                setIsDocModalOpen(false);
              }}
            >
              Accept
            </Button>
          </Can>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
